import { ButtonSecondary } from '@comeon/ui';
import useTranslations from '../../../translation/use-translations';
import { WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import { Modal } from '../../../modal/modal-old.js';
import useContextualPathTransformer from '../../../../hooks/use-contextual-path-transformer.js';
import { ROUTE_WE_SPIN_GAME_ROOM_RULES } from '../constants/we-spin-route-constants.js';
import { useNavigate } from 'react-router-dom';

const WeSpinGameRoomSidebarModal = ({ streamView, openModal, hideModalCallback }) => {
	const navigate = useNavigate();
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_TEXT_KEYS);
	const transformPath = useContextualPathTransformer();
	return (
		!isLoadingTranslations &&
		streamView && (
			<div className="user-options">
				<Modal show={openModal} withinSidebar blurBg>
					<>
						{/* fragment consumes the non-DOM props forwarded by Modal */}
						<div className="u-p1 u-flex-available-height-column u-height-100">
							<div className="u-mta we-spin-edit-stream-modal">
								<ButtonSecondary
									onClick={() => {
										navigate(
											transformPath(`${ROUTE_WE_SPIN_GAME_ROOM_RULES}/${streamView.streamRef}`)
										);
										hideModalCallback();
									}}
									className="u-divider-1"
								>
									{tr.WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_WE_SPIN_GAME_RULES_BUTTON}
								</ButtonSecondary>
								<ButtonSecondary
									onClick={() => {
										navigate(streamView.currentGame.funModeUrl);
									}}
									className="u-divider-1"
								>
									{tr.WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_GAME_RULES_BUTTON}
								</ButtonSecondary>
								<ButtonSecondary onClick={hideModalCallback} className="u-mt1">
									{tr.WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_CANCEL_BUTTON}
								</ButtonSecondary>
							</div>
						</div>
					</>
				</Modal>
			</div>
		)
	);
};

export default WeSpinGameRoomSidebarModal;
